#!/usr/bin/env node

import { Command } from 'commander';
import { cosmiconfig } from 'cosmiconfig';
import pc from 'picocolors';
import { version } from '../package.json';
import { createInitCommand } from './commands/init';
import { createRunCommand } from './commands/run';
import { createSyncCommand } from './commands/sync';
import { createStartCommand } from './commands/start';
import { createStatusCommand } from './commands/status';
import { createKbCommand } from './commands/kb';
import { createConfigCommand } from './commands/config';
import { createTaskCommand } from './commands/task';
import { createWorkflowCommand } from './commands/workflow';
import { createTaskWorkflowCommand } from './commands/task-workflow';
import { createContextCommand } from './commands/context';
import { createAutoDevCommand } from './commands/auto-dev';
import { createTemplateCommand } from './commands/template';
import { createTeamCommand } from './commands/team';
import { createNotifyCommand } from './commands/notify';
import { createOrchestrateCommand } from './commands/orchestrate';
import { createCheckPermissionsCommand } from './commands/check-permissions';
import { logger } from './utils/logger';

async function main() {
  const program = new Command();

  // Load configuration
  const explorer = cosmiconfig('workflow');
  const config = await explorer.search();

  program
    .name('workflow')
    .description('AI-powered workflow management CLI for developers')
    .version(version)
    .alias('wf')
    .option('-d, --debug', 'Enable debug mode')
    .hook('preAction', (thisCommand) => {
      if (thisCommand.opts().debug) {
        process.env.DEBUG = 'true';
        logger.debug('Debug mode enabled');
      }
    });

  // Add commands
  program.addCommand(createInitCommand());
  program.addCommand(createRunCommand());
  program.addCommand(createSyncCommand());
  program.addCommand(createStartCommand());
  program.addCommand(createStatusCommand());
  program.addCommand(createKbCommand());
  program.addCommand(createConfigCommand());
  program.addCommand(createTaskCommand());
  
  // New workflow commands
  program.addCommand(createWorkflowCommand());
  program.addCommand(createTaskWorkflowCommand());
  program.addCommand(createContextCommand());
  program.addCommand(createAutoDevCommand());
  program.addCommand(createTemplateCommand());
  program.addCommand(createTeamCommand());
  program.addCommand(createNotifyCommand());
  program.addCommand(createOrchestrateCommand());
  program.addCommand(createCheckPermissionsCommand());

  // Error handling
  program.exitOverride();

  try {
    await program.parseAsync(process.argv);
  } catch (error: any) {
    if (error.code === 'commander.helpDisplayed') {
      process.exit(0);
    }
    logger.error(error.message);
    if (process.env.DEBUG) {
      console.error(error);
    }
    process.exit(1);
  }
}

main().catch((error) => {
  logger.error('Fatal error:', error);
  process.exit(1);
});